/**
 * Round number.
 *
 * @param {float} number The number.
 * @param {integer} digits The cout of digits.
 * @return { float }
 */
export const round = (number, digits) => {
  const nDigits = Math.pow(10, digits)
  return Math.round(number * nDigits) / nDigits
}
